export enum GetHMChrgStatus {
  UNSET = 'UNSET',
  PENDING = 'PENDING',
  INSTALLED = 'INSTALLED',
  DECLINED = 'DECLINED',
  NOT_SCHEDULED = 'NOT_SCHEDULED'
}
